import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__FIELD_CREATE,
  EDITING_DOCUMENT__FIELD_TARGET_SET,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

type EditingDocumentIsInsertInProgressState = boolean;

const initialState: EditingDocumentIsInsertInProgressState = false;

export default function reducer(
  state: EditingDocumentIsInsertInProgressState = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__FIELD_TARGET_SET:
      return true;
    case EDITING_DOCUMENT__FIELD_CREATE:
    case PDF_CLEAR_ALL_STATE:
      return false;
    default:
      return state;
  }
}
